<div class="control-card-content">

  <div *ngIf="userCanExecutionEdit" class="buttons-container">

    <ng-container id="addProgrammedExecution">
      <a (click)="addExecution()" class="button">
        <ng-container i18n="@@programmed_execution_add_programmed_execution">Aggiungi automatismo programmato
        </ng-container> <span>
          <fa-icon icon="clock"></fa-icon>
        </span>
      </a>
    </ng-container>
  </div>

  <div class="table-filter-programmed">
    <p i18n="@@programmed_executions_filter">Filtra: </p>
    <input id="filter-input" (keyup)="onKey($event)" />
  </div>


  <table mat-table matSort #programmedExecutionstable class="simple-table">

    <ng-container matColumnDef="serial">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@programmed_executions_serial" style="width: 10%;">Seriale
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.serial }} </td>
    </ng-container>


    
    <ng-container matColumnDef="description">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@programmed_executions_description" style="width: 30%;">Descrizione
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
    </ng-container>

    <ng-container matColumnDef="fromDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@programmed_executions_from_date" style="width: 20%;">Data inizio
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.fromDateFriendly }} </td>
    </ng-container>

    <ng-container matColumnDef="toDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@programmed_executions_to_date" style="width: 20%;">Data fine
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.toDateFriendly }} </td>
    </ng-container>

    <ng-container matColumnDef="result">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@programmed_executions_result" style="width: 15%;">Stato
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.result }} </td>
    </ng-container>

    <ng-container matColumnDef="deleteExecution">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element">
        <fa-icon  *ngIf="userCanExecutionEdit" icon="trash" class="float-right padding-5 icon-clickable" (click)="deleteExecution(element)">
        </fa-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsProgrammed"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumnsProgrammed;"></tr>

  </table>

</div>
<app-loading-screen #programmedExecutionsloader [loading]="false"></app-loading-screen>